import { GA } from 'types';

export interface Item {
  itemId: string;
  itemName: string;
  itemCategory: string;
  itemVariant: string;
  index: number;
  quantity: number;
  price: number;
}

export interface SelectItemData {
  type: GA.EventType.SELECT_ITEM;
  itemListId: string;
  itemListName: string;
  currency: string;
  items: Item[];
}

interface EcommerceItem {
  item_id: Item['itemId'];
  item_name: Item['itemName'];
  item_variant: Item['itemVariant'];
  item_category: string;
  index: Item['index'];
  quantity: Item['quantity'];
  price: Item['price'];
}

export interface SelectItemEvent {
  event: SelectItemData['type'];
  event_data: {
    action: GA.Action.VIEW;
    component_type: GA.ComponentType.ITEM_LIST;
  };
  ecommerce: {
    currency: SelectItemData['currency'];
    item_list_id: SelectItemData['itemListId'];
    item_list_name: SelectItemData['itemListName'];
    items: EcommerceItem[];
  };
}

const getSelectItemEvent = (data: SelectItemData): SelectItemEvent => {
  const { items, itemListId, itemListName, type, currency } = data;

  const ecommerceItems = items.map((item) => ({
    item_id: item.itemId,
    item_name: item.itemName,
    item_variant: item.itemVariant,
    index: item.index,
    quantity: item.quantity,
    price: item.price,
    item_category: 'Hotel',
  }));

  return {
    event: type,
    event_data: {
      action: GA.Action.VIEW,
      component_type: GA.ComponentType.ITEM_LIST,
    },
    ecommerce: {
      currency,
      item_list_id: itemListId,
      item_list_name: itemListName,
      items: ecommerceItems,
    },
  };
};

export default getSelectItemEvent;
